import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=7bc57ad8&scoped=true&"
import script from "./sales.vue?vue&type=script&lang=js&"
export * from "./sales.vue?vue&type=script&lang=js&"
import style0 from "./sales.vue?vue&type=style&index=0&id=7bc57ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc57ad8",
  null
  
)

export default component.exports